module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.25921e3e.svg";